import { useQuery } from '@apollo/client'
import { AppState, getAppStateQuery } from 'graphql/queries/app/getAppState'

export const useAppState = () => {
  const { data: appData } = useQuery<AppState>(getAppStateQuery)
  return appData?.appState
}
